import React from 'react';
import { useEffect, useState } from 'react';
import ScholarCard from '../components/ScholarCard.jsx';
import { useFirebase } from "../providers/firebase";
import PastScholarPopupModal from '../components/PastScholarPopupModal.jsx';
import { useAuthentication } from '../providers/authentication.js';

function PostGraduateStudents() {
  const { user } = useAuthentication();
  const { pastPostGradStudents, addPastScholars, editPastScholars, deletePastScholars } = useFirebase();

  const [isModalVisible, setModalVisible] = useState(false);
  const [defaultValue, setDefaultValue] = useState("");

  const handleEdit = (data, index) => {
    setModalVisible(true);
    setDefaultValue(data);
  };

  const handleDelete = (id) => {
    deletePastScholars('postGraduateStudents', id).then(() => {
      window.location.reload();
    });
  };

  const handleAdd = () => {
    setDefaultValue(""); // Empty input for adding
    setModalVisible(true);
  };

  const handleCloseModal = () => {
    setModalVisible(false);
  };

  const handleSubmit = (value, id) => {
    if (defaultValue !== "") {
      console.log(`Edit a past scholar in doctoral scholars with new value: ${value}`);
      editPastScholars('postGraduateStudents', defaultValue.id, value).then(() => {
        window.location.reload();
      });
    } else {
      console.log(`Add a new person in doctoral scholars with value: ${value}`);
      addPastScholars(value, 'postGraduateStudents').then(() => {
        window.location.reload();
      });
    }
    setModalVisible(false);
  };

  const isSmallScreen = window.matchMedia('(max-width: 600px)').matches;

  const styles = {
    container: {
      maxWidth: '900px',
      margin: 'auto',
      padding: '20px',
      textAlign: 'center',
    },
    title: {
      fontFamily: 'Arial, sans-serif',
      marginBottom: '20px',
      fontSize: isSmallScreen ? '24px' : '32px',
    },
    tableContainer: {
      maxHeight: '300px',
      overflowY: 'auto',
      border: '1px solid red',
      marginTop: '10px',
      overflowX: isSmallScreen ? 'auto' : 'hidden',
    },
    table: {
      width: '100%',
      borderCollapse: 'collapse',
      fontSize: isSmallScreen ? '14px' : '16px',
    },
    th: {
      border: '1px solid red',
      padding: isSmallScreen ? '8px' : '12px',
      textAlign: 'left',
      backgroundColor: '#ddd',
      position: 'sticky',
      top: 0,
    },
    td: {
      border: '1px solid red',
      padding: isSmallScreen ? '8px' : '12px',
      textAlign: 'left',
      fontFamily: 'Arial, sans-serif',
    },
  };

  return (
    <div style={styles.container}>
      <h1 style={styles.title}>Post Graduate/Dual-Degree Students {user && (<button className="add-btn" onClick={() => handleAdd('postGraduateStudents')}>Add</button>)}</h1>
      <div style={styles.tableContainer}>
        <table style={styles.table}>
          <thead>
            <tr>
              <th style={styles.th}>Name</th>
              <th style={styles.th}>Year</th>
              <th style={styles.th}>Research Area</th>
              <th style={styles.th}>Current Status / LinkedIn</th>
              {user && <th style={styles.th}>Admin Options</th>}
            </tr>
          </thead>
          <tbody>
            {pastPostGradStudents ? (
              pastPostGradStudents.map((student, index) => (
                <tr
                  key={index}
                >
                  <td style={styles.td}>{student.name}</td>
                  <td style={styles.td}>{student.year}</td>
                  <td style={styles.td}>{student.researchArea}</td>
                  <td style={styles.td}>{student.status}</td>
                  {
                    user ? (
                      <td style={styles.td}>
                        <div className="actions">
                          <button className="edit-btn" onClick={() => handleEdit(student, index)}>
                            Edit
                          </button>
                          <button className="edit-btn" onClick={() => handleDelete(student.id)}>
                            Delete
                          </button>
                        </div>
                      </td>
                    ) : ("")
                  }
                </tr>
              ))) : ("")}
          </tbody>
        </table>
      </div>
      <PastScholarPopupModal
        show={isModalVisible}
        onClose={handleCloseModal}
        onSubmit={handleSubmit}
        defaultValue={defaultValue}
      />
    </div>
  );
}


function ProjectScholars() {
  const { user } = useAuthentication();
  const { pastProjectScholars, addPastScholars, editPastScholars, deletePastScholars } = useFirebase();

  const [isModalVisible, setModalVisible] = useState(false);
  const [defaultValue, setDefaultValue] = useState("");

  const handleEdit = (data, index) => {
    setModalVisible(true);
    setDefaultValue(data);
  };

  const handleDelete = (id) => {
    deletePastScholars('projectScholars', id).then(() => {
      window.location.reload();
    });
  };

  const handleAdd = () => {
    setDefaultValue(""); // Empty input for adding
    setModalVisible(true);
  };

  const handleCloseModal = () => {
    setModalVisible(false);
  };

  const handleSubmit = (value, id) => {
    if (defaultValue !== "") {
      console.log(`Edit a past scholar in doctoral scholars with new value: ${value}`);
      editPastScholars('projectScholars', defaultValue.id, value).then(() => {
        window.location.reload();
      });
    } else {
      console.log(`Add a new person in doctoral scholars with value: ${value}`);
      addPastScholars(value, 'projectScholars').then(() => {
        window.location.reload();
      });
    }
    setModalVisible(false);
  };

  const isSmallScreen = window.matchMedia('(max-width: 600px)').matches;

  const styles = {
    container: {
      maxWidth: '900px',
      margin: 'auto',
      padding: '20px',
      textAlign: 'center',
    },
    title: {
      fontFamily: 'Arial, sans-serif',
      marginBottom: '20px',
      fontSize: isSmallScreen ? '24px' : '32px',
    },
    tableContainer: {
      maxHeight: '300px',
      overflowY: 'auto',
      border: '1px solid red',
      marginTop: '10px',
      overflowX: isSmallScreen ? 'auto' : 'hidden',
    },
    table: {
      width: '100%',
      borderCollapse: 'collapse',
      fontSize: isSmallScreen ? '14px' : '16px',
    },
    th: {
      border: '1px solid red',
      padding: isSmallScreen ? '8px' : '12px',
      textAlign: 'left',
      backgroundColor: '#ddd',
      position: 'sticky',
      top: 0,
    },
    td: {
      border: '1px solid red',
      padding: isSmallScreen ? '8px' : '12px',
      textAlign: 'left',
      fontFamily: 'Arial, sans-serif',
    },
  };

  return (
    <div style={styles.container}>
      <h1 style={styles.title}>Project Scholars {user && (<button className="add-btn" onClick={() => handleAdd('projectScholars')}>Add</button>)}</h1>
      <div style={styles.tableContainer}>
        <table style={styles.table}>
          <thead>
            <tr>
              <th style={styles.th}>Name</th>
              <th style={styles.th}>Year</th>
              <th style={styles.th}>Research Area</th>
              <th style={styles.th}>Current Status / LinkedIn</th>
              {user && <th style={styles.th}>Admin Options</th>}
            </tr>
          </thead>
          <tbody>
            {pastProjectScholars ? (
              pastProjectScholars.map((student, index) => (
                <tr
                  key={index}
                >
                  <td style={styles.td}>{student.name}</td>
                  <td style={styles.td}>{student.year}</td>
                  <td style={styles.td}>{student.researchArea}</td>
                  <td style={styles.td}>{student.status}</td>
                  {
                    user ? (
                      <td style={styles.td}>
                        <div className="actions">
                          <button className="edit-btn" onClick={() => handleEdit(student, index)}>
                            Edit
                          </button>
                          <button className="edit-btn" onClick={() => handleDelete(student.id)}>
                            Delete
                          </button>
                        </div>
                      </td>
                    ) : ("")
                  }
                </tr>
              ))) : ("")}
          </tbody>
        </table>
      </div>
      <PastScholarPopupModal
        show={isModalVisible}
        onClose={handleCloseModal}
        onSubmit={handleSubmit}
        defaultValue={defaultValue}
      />
    </div>
  );
}

function GraduatePhDStudents() {
  const { user } = useAuthentication();
  const { graduatePhDStudents, addPastScholars, editPastScholars, deletePastScholars } = useFirebase();

  const [isModalVisible, setModalVisible] = useState(false);
  const [defaultValue, setDefaultValue] = useState("");

  const handleEdit = (data, index) => {
    setModalVisible(true);
    setDefaultValue(data);
  };

  const handleDelete = (id) => {
    deletePastScholars('graduatePhDStudents', id).then(() => {
      window.location.reload();
    });
  };

  const handleAdd = () => {
    setDefaultValue(""); // Empty input for adding
    setModalVisible(true);
  };

  const handleCloseModal = () => {
    setModalVisible(false);
  };

  const handleSubmit = (value, id) => {
    if (defaultValue !== "") {
      console.log(`Edit a past scholar in doctoral scholars with new value: ${value}`);
      editPastScholars('graduatePhDStudents', defaultValue.id, value).then(() => {
        window.location.reload();
      });
    } else {
      console.log(`Add a new person in doctoral scholars with value: ${value}`);
      addPastScholars(value, 'graduatePhDStudents').then(() => {
        window.location.reload();
      });
    }
    setModalVisible(false);
  };

  const isSmallScreen = window.matchMedia('(max-width: 600px)').matches;

  const styles = {
    container: {
      maxWidth: '900px',
      margin: 'auto',
      padding: '20px',
      textAlign: 'center',
    },
    title: {
      fontFamily: 'Arial, sans-serif',
      marginBottom: '20px',
      fontSize: isSmallScreen ? '24px' : '32px',
    },
    tableContainer: {
      maxHeight: '300px',
      overflowY: 'auto',
      border: '1px solid red',
      marginTop: '10px',
      overflowX: isSmallScreen ? 'auto' : 'hidden',
    },
    table: {
      width: '100%',
      borderCollapse: 'collapse',
      fontSize: isSmallScreen ? '14px' : '16px',
    },
    th: {
      border: '1px solid red',
      padding: isSmallScreen ? '8px' : '12px',
      textAlign: 'left',
      backgroundColor: '#ddd',
      position: 'sticky',
      top: 0,
    },
    td: {
      border: '1px solid red',
      padding: isSmallScreen ? '8px' : '12px',
      textAlign: 'left',
      fontFamily: 'Arial, sans-serif',
    },
  };

  return (
    <div style={styles.container}>
      <h1 style={styles.title}>Graduate PhD Students {user && (<button className="add-btn" onClick={() => handleAdd('graduatePhDStudents')}>Add</button>)}</h1>
      <div style={styles.tableContainer}>
        <table style={styles.table}>
          <thead>
            <tr>
              <th style={styles.th}>Name</th>
              <th style={styles.th}>Year</th>
              <th style={styles.th}>Research Area</th>
              <th style={styles.th}>Current Status / LinkedIn</th>
              {user && <th style={styles.th}>Admin Options</th>}
            </tr>
          </thead>
          <tbody>
            {graduatePhDStudents ? (
              graduatePhDStudents.map((student, index) => {
                console.log(student.researchArea);
                return (
                  <tr
                    key={index}
                  >
                    <td style={styles.td}>{student.name}</td>
                    <td style={styles.td}>{student.year}</td>
                    <td style={styles.td}>{student.researchArea}</td>
                    <td style={styles.td}>{student.status}</td>
                    {
                      user ? (
                        <td style={styles.td}>
                          <div className="actions">
                            <button className="edit-btn" onClick={() => handleEdit(student, index)}>
                              Edit
                            </button>
                            <button className="edit-btn" onClick={() => handleDelete(student.id)}>
                              Delete
                            </button>
                          </div>
                        </td>
                      ) : ("")
                    }
                  </tr>
                )
              })) : ("")}
          </tbody>
        </table>
      </div>
      <PastScholarPopupModal
        show={isModalVisible}
        onClose={handleCloseModal}
        onSubmit={handleSubmit}
        defaultValue={defaultValue}
      />
    </div>
  );
}

function Scholars() {
  return (
    <div className="pastScholars-page-container">
      <div className="pastScholars-heading">Past Scholars</div>
      <GraduatePhDStudents />
      <PostGraduateStudents />
      <ProjectScholars />
      <div className="pastScholars-copyright">
        (c) All Rights Reserved by VSIMA Lab, SECS, IIT Bhubaneswar, 2024
      </div>
    </div>
  )
}
export default Scholars;
